<template>
    <div class="configurator-styleguide">

        <ElementStyling />
    </div>
</template>

<script>
    // @ is an alias to /src
    import ElementStyling from '@/components/ElementStyling.vue'

    export default {
        name: 'style_guide',
        components: {
            ElementStyling
        }
    }
</script>
